import React from "react";
import { Outlet } from 'react-router-dom';
import Navbar from "../Navbar/Navbar";
import Footer from "../Footer/Footer";
import CookieConsent from "../CookieConsent/CookieConsent";
import './SharedLayout.css';

const SharedLayout = () => {
    return (
        <div className="SharedLayout">
            <main>
                <Navbar />
                <Outlet />
            </main>
            <Footer />
            <CookieConsent />
        </div>
    )
}

export default SharedLayout;